import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["art", "track", "artist", "playPause", "bar"]
  static values = {
    nowPlayingUrl: String,
    pauseUrl:      String,
    resumeUrl:     String,
    nextUrl:       String,
    prevUrl:       String
  }

  connect() {
    this.isPlaying = false
    this.poll()
    this.interval = setInterval(() => this.poll(), 5000)
    this.showHandler = () => this.poll()
    window.addEventListener("spotify:show", this.showHandler)
  }

  disconnect() {
    clearInterval(this.interval)
    window.removeEventListener("spotify:show", this.showHandler)
  }

  async poll() {
    try {
      const res = await fetch(this.nowPlayingUrlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
      if (res.status === 204 || res.status === 200 && res.headers.get("content-length") === "0") {
        this.hide(); return
      }
      if (!res.ok) { this.hide(); return }
      const data = await res.json()
      if (!data.track_name) { this.hide(); return }
      this.render(data)
    } catch (_) {
      this.hide()
    }
  }

  render(data) {
    this.isPlaying = data.is_playing
    if (this.hasArtTarget)    this.artTarget.src = data.album_art || ""
    if (this.hasTrackTarget)  this.trackTarget.textContent = data.track_name || ""
    if (this.hasArtistTarget) this.artistTarget.textContent = data.artist_name || ""
    this.updatePlayPause()
    this.element.classList.remove("hidden")
  }

  hide() {
    this.element.classList.add("hidden")
  }

  updatePlayPause() {
    if (!this.hasPlayPauseTarget) return
    this.playPauseTarget.innerHTML = this.isPlaying ? pauseIcon() : playIcon()
  }

  async togglePlayPause(event) {
    event.preventDefault()
    const url = this.isPlaying ? this.pauseUrlValue : this.resumeUrlValue
    await this.post(url)
    this.isPlaying = !this.isPlaying
    this.updatePlayPause()
  }

  async next(event) {
    event.preventDefault()
    await this.post(this.nextUrlValue)
    setTimeout(() => this.poll(), 800)
  }

  async prev(event) {
    event.preventDefault()
    await this.post(this.prevUrlValue)
    setTimeout(() => this.poll(), 800)
  }

  post(url) {
    return fetch(url, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content }
    })
  }
}

function playIcon() {
  return `<svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd"/>
  </svg>`
}

function pauseIcon() {
  return `<svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"/>
  </svg>`
}
